import React, { useState } from 'react';
import { ArrowClockwise } from '@phosphor-icons/react';

import { Button } from '../../../components/general';
import AttendeePanel from './attendeePanel';

const DadJokesPanel: React.FC = () => {
  const dadJokes = [
    'Did you hear about the circus fire? It was in tents!',
    'How do you catch a squirrel? Climb a tree and act like a nut!',
    'Did you hear about the guy who invented Lifesavers? They say he made a mint!',
    'I told my wife she should embrace her mistakes. She gave me a hug.',
    "Why don't eggs tell jokes? They might crack up!",
    'What did the big flower say to the little flower? Hi, bud!',
    "I went to buy some camouflage pants, but I couldn't find any.",
    'What did the grape say when it got stepped on? Nothing, it just let out a little wine.',
    'I used to have a job at a calendar factory, but I got fired because I took a couple of days off.',
    'What do you call a snowman with a six-pack? An abdominal snowman!',
    "Why don't skeletons fight each other? They don't have the guts!",
    'Did you hear about the restaurant on the moon? Great food, no atmosphere!',
    "What did one wall say to the other wall? I'll meet you at the corner!",
    'Why did the math book look sad? Because it had too many problems!',
    "What did one hat say to the other hat? You stay here, I'll go on ahead!",
    'Why did the coffee file a police report? It got mugged!',
    "I was going to tell you a joke about time travel, but you didn't like it.",
    "I used to be a baker, but I couldn't make enough dough.",
    'Did you hear about the guy who got hit in the head with a can of soda? He was lucky it was a soft drink.',
    "I'm writing a book about glue, but I'm stuck on the first chapter.",
    'What did one plate whisper to the other plate? Dinner is on me.',
    'Why did the golfer bring two pairs of pants? In case he got a hole in one.',
    'Two sheep walk into a—baaaa.',
    'Stop looking for the perfect match; use a lighter.',
    'Try the seafood diet — you see food, then you eat it.',
    "Did you hear the rumor about butter? Well, I'm not going to go spreading it!",
    "What's Forrest Gump's password? 1forrest1",
    'What state is known for its small drinks? Minnesota.',
    'What does a nosey pepper do? It gets jalapeño business.',
    'If two vegetarians get in an argument, is it still called beef?',
    "I have a clean conscious — it's never been used.",
    'I love telling Dad jokes. Sometimes, he even laughs.',
  ];

  const getRandomIndex = () => {
    return Math.floor(Math.random() * dadJokes.length);
  };

  const [jokeIndex, setJokeIndex] = useState(getRandomIndex());

  return (
    <AttendeePanel
      heading="Enjoy Some Dad Jokes While You're Waiting"
      className="w-full items-center gap-8 text-center"
    >
      <div>{dadJokes[jokeIndex]}</div>

      <Button
        onClick={() => setJokeIndex(getRandomIndex())}
        colour="black-outline"
        className="w-1/3 font-semibold"
        withGap
      >
        <ArrowClockwise size="1.25rem" />
        <div>New Joke</div>
      </Button>
    </AttendeePanel>
  );
};

export default DadJokesPanel;
